import React, { useCallback } from 'react';
import GuidePopover from '../guidePopover';
import ImgBubbleGuideContent from './imgBubbleGuideContent';
const ImgBubbleGuide = props => {
    const { show, guideId, step, onStep, title, intro, renderFooter, placement, children, okText, onClose, showArrow, arrowDistance, contentImg, getPopupContainer } = props;
    const Content = useCallback(() => {
        const imgProps = {
            guideId,
            step,
            onStep,
            okText,
            title,
            intro,
            renderFooter,
            contentImg,
            onClose,
        };
        return React.createElement(ImgBubbleGuideContent, Object.assign({}, imgProps));
    }, [guideId, step, onStep, okText, title, intro, renderFooter, contentImg, onClose]);
    return (React.createElement(GuidePopover, { type: "2", content: show ? React.createElement(Content, null) : React.createElement(React.Fragment, null), placement: placement, visible: !!show, showArrow: showArrow, arrowDistance: arrowDistance, getPopupContainer: getPopupContainer }, children));
};
export default ImgBubbleGuide;
